"use strict";

exports.__esModule = true;
exports["default"] = registerTarget;

function registerTarget(type, target, manager) {
  var registry = manager.getRegistry();
  var targetId = registry.addTarget(type, target);

  function unregisterTarget() {
    registry.removeTarget(targetId);
  }

  return {
    handlerId: targetId,
    unregister: unregisterTarget
  };
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dnd/lib/registerTarget.js
 ** module id = 369
 ** module chunks = 0
 **/